import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { Space } from 'antd';
import { history } from 'umi';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import { FTourMgr } from '@/utils/FTourMgr';
import FIcons from '@/components/FIcons';

interface CreatorEntryProps {}

function creatorEntry({}: CreatorEntryProps) {
  AHooks.useMount(() => {
    FTourMgr.init('resource.creatorEntry', [
      {
        element: self.document.getElementById('resource.creatorEntry.resourceCreatorCard'),
        title: FI18n.i18nNext.t('tours_createresource_new'),
      },
      {
        element: self.document.getElementById('resource.creatorEntry.resourceCreatorBatchCard'),
        title: FI18n.i18nNext.t('tours_createresource_bulk'),
      },
      {
        element: self.document.getElementById('resource.creatorEntry.collectionCreatorCard'),
        title: FI18n.i18nNext.t('tours_createresource_collection'),
      },
    ]);
  });

  return (
    <div className={styles.creatorEntry}>
      <div id={'resource.creatorEntry.resourceCreatorCard'} className={styles.card}>
        <FIcons.FResourceFile className={styles.icon} />
        <div className={styles.cardText}>
          {FI18n.i18nNext.tJSXElement('addnewresource_option_single_msg')}
        </div>
        <FComponentsLib.FRectBtn
          onClick={() => {
            history.push(FUtil.LinkTo.resourceCreator());
          }}
        >
          {FI18n.i18nNext.tAuto('addnewresource_option_single_btn')}
        </FComponentsLib.FRectBtn>
      </div>
      <div id={'resource.creatorEntry.resourceCreatorBatchCard'} className={styles.card}>
        <Space size={15}>
          <FIcons.FResourceFile className={styles.icon} />
          <FIcons.FResourceFile className={styles.icon} />
          <FIcons.FResourceFile className={styles.icon} />
        </Space>
        <div className={styles.cardText}>
          {FI18n.i18nNext.tJSXElement('addnewresource_option_bulk_msg')}
        </div>
        <FComponentsLib.FRectBtn
          onClick={() => {
            history.push(FUtil.LinkTo.resourceCreatorBatch());
          }}
        >
          {FI18n.i18nNext.tAuto('addnewresource_option_bulk_one')}
        </FComponentsLib.FRectBtn>
      </div>

      <div id={'resource.creatorEntry.collectionCreatorCard'} className={styles.card}>
        <Space size={15}>
          <FIcons.FResource className={styles.icon} />
        </Space>
        <div className={styles.cardText}>
          {FI18n.i18nNext.tJSXElement('addnewresource_option_collection_msg')}
        </div>
        <FComponentsLib.FRectBtn
          onClick={() => {
            history.push(FUtil.LinkTo.collectionCreator());
          }}
        >
          {FI18n.i18nNext.tAuto('addnewresource_option_collection')}
        </FComponentsLib.FRectBtn>
      </div>
    </div>
  );
}

export default creatorEntry;
